import { AngularFireDatabaseModule} from '@angular/fire/database';
import { UploadService } from './service/upload.service';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import firebase from 'firebase';
import { AngularFireModule } from '@angular/fire';
import { environment } from '../environments/environment';
import { NotifierModule } from 'angular-notifier';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AboutComponent } from './component/about/about.component';
import { PortfolioComponent } from './component/portfolio/portfolio.component';
import { BlogComponent } from './component/blog/blog.component';
import { ContactComponent } from './component/contact/contact.component';
import { SinglePostComponent } from './component/single-post/single-post.component';
import { HomeComponent } from './component/home/home.component';
import { AdminComponent } from './component/admin/admin.component';
import { AuthGuard } from './service/auth.guard';
import { AuthService } from './service/auth.service';
import { LoginComponent } from './component/login/login.component';
import { AdmBlogComponent } from './component/admin/tab/adm-blog/adm-blog.component';
import { AdmPortfolioComponent } from './component/admin/tab/adm-portfolio/adm-portfolio.component';
import {AngularFireStorageModule} from '@angular/fire/storage';

import { USE_EMULATOR as USE_AUTH_EMULATOR } from '@angular/fire/auth';
import { USE_EMULATOR as USE_DATABASE_EMULATOR } from '@angular/fire/database';
import { USE_EMULATOR as USE_FIRESTORE_EMULATOR } from '@angular/fire/firestore';
import { USE_EMULATOR as USE_FUNCTIONS_EMULATOR } from '@angular/fire/functions';
import {TabsModule} from 'ngx-bootstrap/tabs';
import {TabComponent} from './component/admin/tab/TabComponent';
import {TabsComponent} from './component/admin/tab/TabsComponent';
import {BlogService} from './service/blog.service';

firebase.initializeApp(environment.firebase);

@NgModule({
  declarations: [
    AppComponent,
    AboutComponent,
    PortfolioComponent,
    BlogComponent,
    ContactComponent,
    SinglePostComponent,
    HomeComponent,
    AdminComponent,
    LoginComponent,
    AdmBlogComponent,
    AdmPortfolioComponent,
    TabComponent,
    TabsComponent
  ],
  imports: [
    BrowserModule,
    FormsModule, ReactiveFormsModule,
    AppRoutingModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireDatabaseModule,
    AngularFireStorageModule,
    NotifierModule,
    TabsModule.forRoot(),
  ],
  providers: [
    AuthGuard, AuthService, UploadService, BlogService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
